import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function HomePage() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "TaxiService",
    "name": "Başharık Taksi",
    "alternateName": "Başharık Taksi Malatya",
    "description": "Malatya'nın en güvenilir taksi hizmeti. 7/24 havalimanı transferi, şehir içi ve şehirler arası ulaşım. Kredi kartı geçerli.",
    "url": "https://topraksutaksi.com",
    "logo": "https://topraksutaksi.com/logo.avif",
    "image": "https://topraksutaksi.com/8.jpg",
    "telephone": ["+905308920944", "+905302064644"],
    "priceRange": "₺₺",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Malatya",
      "addressRegion": "Malatya",
      "addressCountry": "TR",
      "postalCode": "44000"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 38.3552,
      "longitude": 38.3095
    },
    "areaServed": {
      "@type": "City",
      "name": "Malatya"
    },
    "serviceType": [
      "Şehir İçi Taksi",
      "Şehirler Arası Taksi",
      "Havalimanı Transferi",
      "7/24 Taksi Hizmeti"
    ],
    "paymentAccepted": "Kredi Kartı, Nakit",
    "currenciesAccepted": "TRY",
    "openingHours": "Mo-Su 00:00-23:59",
    "sameAs": [
      "https://instagram.com/44t0702"
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5",
      "reviewCount": "50"
    }
  };

  const breadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Ana Sayfa",
        "item": "https://topraksutaksi.com/"
      }
    ]
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData, null, 2) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbData, null, 2) }}
      />
      <main className="min-h-screen">
        <Hero />
        <Services />
        <About />
        <Testimonials />
        <CTA />
        <Footer />
      </main>
    </>
  );
}
